// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3qqjZ","head":"ProcedureTableInfo_head__3yMnA"};